import { Record } from 'immutable';

import { FormulaListEntity } from '../components/formula-list/formula-list.entity';
import { FormulaUsageListEntity } from '../components/formula-usage-list/formula-usage-list.entity';

export interface IFormulaState {
	loading: boolean;
	list: FormulaUsageListEntity;
	allUsageCount: number;
	formulaList: FormulaListEntity;
}

export const defaults: IFormulaState = {
	loading: false,
	list: FormulaUsageListEntity.build([]),
	allUsageCount: 0,
	formulaList: FormulaListEntity.build([]),
};

export const FormulaFeatureKey = 'formulas';

export class FormulaState extends Record<IFormulaState>(defaults) {
	public static key = FormulaFeatureKey;

	public setLoading(isLoading: boolean): FormulaState {
		return this.set('loading', isLoading);
	}

	public setFormulaUsages(usages: FormulaUsageListEntity): FormulaState {
		return this.set('list', usages);
	}

	public selAllUsageCount(allUsageCount: number): FormulaState {
		return this.set('allUsageCount', allUsageCount);
	}

	public setFormulaList(formulaList: FormulaListEntity): FormulaState {
		return this.set('formulaList', formulaList);
	}
}
